/**
 * @since 2016-07-31 19:09
 * @author vivaxy
 */

import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';

import '../lib/reset.css';
const ID_SELECTOR = 'root';

export default (App) => {

    return render(
        <AppContainer>
                <App />
        </AppContainer>,
        document.getElementById(ID_SELECTOR)
    );
};



// WEBPACK FOOTER //
// ./src/lib/render.js